import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import heroImage from "@assets/new_hero_image_fillthetrucks_1773855003640.jpeg";

export default function NewMarketingHero() {
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 pt-16 md:pt-24 pb-10 grid md:grid-cols-[55%_45%] gap-12 items-center">
        <div className="space-y-6">
          <h1
            className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight tracking-tight"
            data-testid="heading-hero"
          >
            Post. Invite.<br />
            Compare Bids.<br />
            All in one place.
          </h1>

          <p
            className="text-lg md:text-xl text-muted-foreground max-w-xl"
            data-testid="text-hero-body"
          >No more juggling email threads and phone calls to get multiple bids on every shipment. One post notifies your partners automatically — compare all bids side by side, ask questions, and accept the best bid for you. </p>

          <div className="flex flex-wrap gap-4">
            <Button
              size="lg"
              className="text-base px-8"
              data-testid="button-get-started"
              onClick={() => (window.location.href = "/register")}
            >Start Free</Button>
            <Link href="/how-it-works">
              <Button
                size="lg"
                variant="outline"
                className="text-base px-8"
                data-testid="button-see-how"
              >
                See How It Works
              </Button>
            </Link>
          </div>
        </div>

        <div className="relative">
          <img
            src={heroImage}
            alt="Fill The Trucks platform dashboard on desktop and mobile"
            className="w-full h-auto rounded-md shadow-lg"
          />
        </div>
      </div>
      <div className="bg-gray-100 dark:bg-muted/30">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex divide-x divide-gray-200 dark:divide-gray-700">
          {[
            { value: "Free", label: "No credit card required" },
            { value: "0%", label: "Commission on loads" },
            { value: "1 post", label: "Notifies all your partners" },
            { value: "$0", label: "To get started" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="flex-1 py-5 flex flex-col items-center gap-1"
              data-testid={`stat-${stat.label}`}
            >
              <span className="text-3xl font-bold text-primary text-center">{stat.value}</span>
              <span className="text-sm text-muted-foreground text-center">{stat.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
